import type { CSSProperties } from "react";

interface BookingReferenceLineProps {
  bookingReference: string;
  trackingId?: string;
}

const valueStyle: CSSProperties = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  direction: "rtl",
  textAlign: "left",
};

const BookingReferenceLine = ({ bookingReference, trackingId }: BookingReferenceLineProps) => (
  <span style={{ display: "flex", minWidth: 0 }}>
    <span title={bookingReference} style={{ ...valueStyle, flex: "0 100 auto", minWidth: "4ch" }}>
      <bdi>{bookingReference}</bdi>
    </span>
    {trackingId ? (
      <>
        <span style={{ flexShrink: 0, whiteSpace: "pre" }}> / </span>
        <span title={trackingId} style={{ ...valueStyle, flex: "0 1 auto", minWidth: 0, maxWidth: "8ch" }}>
          <bdi>{trackingId}</bdi>
        </span>
      </>
    ) : null}
  </span>
);

export default BookingReferenceLine;
